import "./Accent.css";

export default function Accent() {
    return <div className="accent"></div>
}